import React, { useState, useEffect } from "react";
import classes from "../../../assets/styles/Pages/Function/FormBuilder.module.css";
import { Modal, Button } from "react-bootstrap";
import Loader from "../../../components/Loader";
import { loggedInUser, teamIDCheck } from "../../../utils/store";
import { useAtom } from "jotai";
import { Link, useNavigate, useParams } from "react-router-dom";
import FormInput from "../../../components/Forms/FormInput";
import { post, put, get } from "../../../server";
import { FORM_BUILDER } from "../../../utils/constants/apiUrl";
import showToast from "../../../helpers/showToast";
import { Form } from "react-bootstrap";
import { Colors } from "../../../utils/data/CardFunctionsData";
import PhoneInput from "react-phone-input-2";
import countries from "country-codes-list";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { BsFillPersonFill, BsFillPeopleFill } from "react-icons/bs";
import { MdEmail, MdLocationOn, MdOutlineContentCopy } from "react-icons/md";
import { BiChevronDown, BiChevronUp } from "react-icons/bi";
import {
  BiGlobe,
  BiSolidPhoneCall,
  BiLogoFacebookCircle,
  BiSolidTrash,
  BiEdit,
  BiLogoTiktok,
  BiLogoSnapchat,
} from "react-icons/bi";
import { PiBuildingsBold } from "react-icons/pi";
import { IoDocumentText } from "react-icons/io5";
import { IoLogoWhatsapp, IoLogoGoogle, IoLogoLinkedin } from "react-icons/io";
import { RiInstagramFill, RiTwitterXFill, RiYoutubeFill } from "react-icons/ri";
import InputText from "../../../assets/images/function_page_icons/input.svg";
import Line from "../../../assets/images/function_page_icons/line.svg";
import Heading from "../../../assets/images/function_page_icons/heading.svg";
import List from "../../../assets/images/function_page_icons/list.svg";
import RadioGroup from "../../../assets/images/function_page_icons/radio.svg";
import Checkbox from "../../../assets/images/function_page_icons/checkbox.svg";
import Dropdown from "../../../assets/images/function_page_icons/dropdown.svg";
import Date from "../../../assets/images/function_page_icons/calendar.svg";
import Paragraph from "../../../assets/images/function_page_icons/paragraph.svg";
import Textarea from "../../../assets/images/function_page_icons/textarea.svg";
import Upload from "../../../assets/images/function_page_icons/upload.svg";
import AddLink from "../../../assets/images/function_page_icons/link.svg";

function ViewFormBuilder() {
  let { id } = useParams();
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [userTeamId, setUserTeamId] = useAtom(teamIDCheck);
  const [loading, setLoading] = useState(false);
  const [formElements, setFormElements] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editLabel, setEditLabel] = useState("");
  const [editOptions, setEditOptions] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedColor, setSelectedColor] = useState([]);
  const [addedPreDefinedComponents, setAddedPreDefinedComponents] = useState(
    []
  );
  const [showSubmitButton, setShowSubmitButton] = useState(false);
  const [selectedFieldTypes, setSelectedFieldTypes] = useState(
    new Array(formElements.length).fill("")
  );
  const [isRequired, setIsRequired] = useState(
    new Array(formElements.length).fill(false)
  );
  const [formName, setFormName] = useState("");
  const navigate = useNavigate();

  const countryCodes = require("country-codes-list");

  const generateCountryOptions = () => {
    const myCountryCodesObject = countryCodes.customList(
      "countryCode",
      "[{countryCode}] {countryNameEn}: +{countryCallingCode}"
    );
    const countryOptions = Object.entries(myCountryCodesObject).map(
      ([code, label]) => ({
        value: code,
        label: label.replace(`[${code}] `, ""),
      })
    );

    return countryOptions;
  };

  const [preDefineItems, setPreDefineItems] = useState([
    {
      id: 1,
      icon: <BsFillPersonFill />,
      label: "First Name",
      checked: false,
      type: "input",
      field_type: "first_name",
    },
    {
      id: 2,
      icon: <BsFillPersonFill />,
      label: "Last Name",
      checked: false,
      type: "input",
      field_type: "last_name",
    },
    {
      id: 3,
      icon: <MdEmail />,
      label: "Email Address",
      checked: false,
      type: "input",
      field_type: "email",
    },
    {
      id: 4,
      icon: <BiSolidPhoneCall />,
      label: "Phone Number",
      checked: false,
      type: "custom",
      field_type: "contact_no",
    },
    {
      id: 5,
      icon: <MdLocationOn />,
      label: "Location",
      checked: false,
      type: "custom",
      field_type: "location",
    },
    {
      id: 6,
      icon: <IoDocumentText />,
      label: "Information",
      checked: false,
      type: "textarea",
      field_type: "description",
    },
  ]);

  const handleFieldTypeChange = (value, index) => {
    const updatedSelectedFieldTypes = [...selectedFieldTypes];
    updatedSelectedFieldTypes[index] = value;
    setSelectedFieldTypes(updatedSelectedFieldTypes);
  };

  const toggleIsRequired = (index) => {
    const updatedIsRequired = [...isRequired];
    updatedIsRequired[index] = !updatedIsRequired[index];
    setIsRequired(updatedIsRequired);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const toggleCheckbox = (id) => {
    const updatedCheckboxItems = preDefineItems.map((item) =>
      item.id === id ? { ...item, checked: !item.checked } : item
    );
    setPreDefineItems(updatedCheckboxItems);
  };

  const addElement = (type, label, options = []) => {
    if (
      (type === "radio" && options.length < 2) ||
      (type === "checkbox" && options.length < 1) ||
      (type === "list" && options.length < 1) ||
      (type === "dropdown" && options.length < 2)
    ) {
      return;
    }

    setFormElements([...formElements, { type, label, options }]);
    setShowSubmitButton(true);
  };

  const addPredefinedElementsToForm = () => {
    const checkedItems = preDefineItems.filter(
      (item) => item.checked && !addedPreDefinedComponents.includes(item.id)
    );
    const elementsToAdd = checkedItems.map((item) => ({
      type: item.type,
      label: item.label,
      isPreDefined: true,
      fieldType: item.field_type,
    }));
    setFormElements([...formElements, ...elementsToAdd]);
    setAddedPreDefinedComponents([
      ...addedPreDefinedComponents,
      ...checkedItems.map((item) => item.id),
    ]);

    showToast("success", "Add component submitted successfully");
    setShowSubmitButton(true);
  };

  const removeElement = (index) => {
    const updatedElements = [...formElements];
    updatedElements.splice(index, 1);
    setFormElements(updatedElements);
    setShowSubmitButton(updatedElements.length > 0);
  };

  const copyElement = (index) => {
    const copiedElement = { ...formElements[index] };
    setFormElements([...formElements, copiedElement]);
    setShowSubmitButton(true);
  };

  const openEditModal = (index, label, options) => {
    setEditingIndex(index);
    setEditLabel(label);
    setEditOptions(options || []);
  };

  const saveEdit = () => {
    if (editingIndex !== null) {
      const updatedElements = [...formElements];
      if (editOptions.length === 0) {
        updatedElements[editingIndex].label = editLabel;
      } else {
        updatedElements[editingIndex].label = editLabel;
        updatedElements[editingIndex].options = editOptions;
      }
      setFormElements(updatedElements);
    }
    setEditingIndex(null);
    setEditLabel("");
    setEditOptions([]);
  };

  const getFormData = async () => {
    let { status, message, data } = await get(
      `${FORM_BUILDER}/${id}`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      setFormName(data.name);
      const formElementsFromAPI = data.formBuilderField.map((field) => ({
        type: field.type === "inputbox" ? "input" : field.type,
        label: field.label,
        options: field.formBuilderFieldData.map((option) => option.data),
        isPreDefined: field.is_predefined,
        fieldType: field.field_type,
      }));
      setFormElements(formElementsFromAPI);
      const updatedIsRequired = data.formBuilderField.map(
        (field) => field.is_required
      );
      setIsRequired(updatedIsRequired);
      setShowSubmitButton(true);

      const fieldTypeValues = data.formBuilderField.map(
        (field) => field.field_type
      );
      setSelectedFieldTypes(fieldTypeValues);
    } else {
      showToast(status, message);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (id) {
      getFormData();
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formBuilderFields = formElements.map((element, index) => {
      //const fieldData = element.options || [];
      const fieldData =
        element.type === "color"
          ? Colors.map((color) => color.bgColor)
          : element.options || [];

      return {
        label: element.label,
        type: element.type === "input" ? "inputbox" : element.type,
        field_type: selectedFieldTypes[index] || element.fieldType,
        is_required: element.isPreDefined
          ? true
          : isRequired[index]
          ? isRequired[index]
          : false,
        is_predefined: element.isPreDefined || false,
        formBuilderFieldData: fieldData,
      };
    });

    const payload = {
      team_id: userTeamId,
      name: formName,
      formBuilderFields: formBuilderFields,
    };
    if (id) {
      let { status, message, data } = await put(
        userTeamId
          ? `${FORM_BUILDER}/${id} + queryString`
          : `${FORM_BUILDER}/${id}`,
        payload,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );

      if (status) {
        navigate("/formBuilder");
      } else {
        showToast(status, message);
      }
    } else {
      let { status, message, data } = await post(
        `${FORM_BUILDER}`,
        payload,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );

      if (status) {
        navigate("/formBuilder");
      } else {
        showToast(status, message);
      }
      showToast(status, message);
    }
    // let { status, message, data } = await post(
    //   FORM_BUILDER,
    //   payload,
    //   Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    // );

    setLoading(false);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <>
      {!loading ? (
        <>
          <div className="">
            <div className={classes.mainWrapper}>
              <h6 className={classes.title}>
                <Link
                  onClick={handleGoBack}
                  style={{ color: "var(--heading_text_color)" }}
                >
                  Lead Builder
                </Link>
                {` > View Lead Builder`}
              </h6>
            </div>
            <div className="row">
              <div className="col-md-8">
                <div className={classes.builderWrapper}>
                  <div className={`${classes.formName} formName`}>
                    {/* <FormInput
                      type="text"
                      label="Form name"
                      placeholder="Enter form name"
                    /> */}
                    <FormInput
                      type="text"
                      label="Form name"
                      placeholder="Enter form name"
                      value={formName}
                      onChange={(e) => setFormName(e.target.value)}
                    />
                  </div>
                  {/* <h6 className="mb-3">Create a Form</h6> */}
                  <form className={`${classes.formWrapper} formWrapper`}>
                    {formElements.map((element, index) => (
                      <div className="position-relative mb-4" key={index}>
                        {element.type === "input" && (
                          <div className={classes.formInput}>
                            <FormInput
                              type="text"
                              label={element?.label}
                              name={element?.label}
                            />
                          </div>
                        )}
                        {element.type === "textarea" && (
                          <div className={classes.formInput}>
                            <h6 className="mb-3">{element?.label}</h6>
                            <textarea
                              className="globalTextArea"
                              type="text"
                              name="description"
                            ></textarea>
                          </div>
                        )}
                        {element.type === "radio" && (
                          <div className={classes.formInput}>
                            <h6>{element.label}</h6>
                            {element.options.map((option, optionIndex) => (
                              <div key={optionIndex}>
                                <input type="radio" />
                                <label>{option}</label>
                              </div>
                            ))}
                          </div>
                        )}
                        {element.type === "checkbox" && (
                          <div className={classes.formInput}>
                            <h6>{element.label}</h6>
                            {element.options.map((option, optionIndex) => (
                              <div key={optionIndex}>
                                <input type="checkbox" />
                                <label>{option}</label>
                              </div>
                            ))}
                          </div>
                        )}

                        {element.type === "list" && (
                          <div className={classes.formInput}>
                            <h5>{element.label}</h5>
                            <ul
                              style={{
                                listStyleType: "disc",
                                paddingLeft: "1rem",
                              }}
                            >
                              {element.options.map((option, optionIndex) => (
                                <li key={optionIndex}>{option}</li>
                              ))}
                            </ul>
                          </div>
                        )}

                        {element.type === "line" && (
                          <div>
                            <h6>{element.label}</h6>
                            <hr
                              style={{
                                borderTopColor: "var(--border_color)",
                                opacity: "1",
                              }}
                            />
                          </div>
                        )}
                        {element.type === "paragraph" && (
                          <div>
                            <h6>Paragraph</h6>
                            <p>{element.label}</p>
                          </div>
                        )}
                        {element.type === "heading" && <h4>{element.label}</h4>}
                        {element.type === "preDropdown" && (
                          <div className={classes.selectWrapper}>
                            <h6 className="mb-1">{element.label}</h6>
                            <div className="input-group globalInputWithIcon">
                              <select
                                style={{ border: "0" }}
                                className="form-select customSelect"
                              >
                                <option value="" disabled>
                                  Select
                                </option>
                                <option value="home">Home</option>
                                <option value="mobile">Mobile</option>
                                <option value="office">Office</option>
                              </select>
                            </div>
                          </div>
                        )}
                        {element.type === "pronounsDropdown" && (
                          <div className={classes.selectWrapper}>
                            <h6>{element.label}</h6>
                            <div className="input-group globalInputWithIcon">
                              <select
                                style={{ border: "0" }}
                                className="form-select customSelect"
                              >
                                <option value="" disabled>
                                  Select
                                </option>
                                <option value="she/her">She/Her</option>
                                <option value="he/him">He/Him</option>
                                <option value="they/them">They/Them</option>
                              </select>
                            </div>
                          </div>
                        )}
                        {element.type === "dropdown" && (
                          <div className={classes.selectWrapper}>
                            <h6>{element.label}</h6>
                            <div className="input-group globalInputWithIcon">
                              <select
                                style={{ border: "0" }}
                                className="form-select customSelect"
                              >
                                {element.options.map((option, optionIndex) => (
                                  <option key={optionIndex} value={option}>
                                    {option}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        )}

                        {element.type === "date" && (
                          <div className={classes.formInput}>
                            <div>
                              <h6 className="mb-3">{element.label}</h6>
                              <DatePicker
                                // selected={formData[field.label]}
                                // onChange={(date) =>
                                //   handleDateInputChange(field.label, date)
                                // }
                                name={element?.label}
                                dateFormat="MM/dd/yyyy"
                                placeholderText="MM/dd/yyyy"
                                showYearDropdown
                                className="dobInput profile"
                                isClearable
                                //maxDate={new Date()}
                                yearDropdownItemNumber={110}
                                scrollableYearDropdown
                              />
                            </div>
                          </div>
                        )}
                        {element.type === "upload" && (
                          <div className={classes.formInput}>
                            <h6 className="mb-3">{element.label}</h6>
                            <input type="file" />
                          </div>
                        )}
                        {element.type === "link" && (
                          <div className={classes.formInput}>
                            <h6 className="mb-3">{element.label}</h6>
                            <input type="url" />
                          </div>
                        )}
                        {element.type === "custom" &&
                          (element.fieldType === "location" ? (
                            <div className="row">
                              <div className="col-lg-4">
                                <div className={classes.formInput}>
                                  <FormInput
                                    type="text"
                                    label="Country"
                                    name={element?.label}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-4">
                                <div className={classes.formInput}>
                                  <FormInput
                                    type="text"
                                    label="State"
                                    name={element?.label}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-4">
                                <div className={classes.formInput}>
                                  <FormInput
                                    type="text"
                                    label="City"
                                    name={element?.label}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-12">
                                <div className={classes.formInput}>
                                  <FormInput
                                    type="text"
                                    label="Address"
                                    name={element?.label}
                                  />
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="row">
                              <div className="col-12">
                                <h6 className="mb-1">{element.label}</h6>
                              </div>
                              <div className="col-md-4">
                                <div className={classes.selectWrapper}>
                                  <div className="input-group globalInputWithIcon">
                                    <select
                                      style={{ border: "0" }}
                                      className="form-select customSelect"
                                    >
                                      <option value="" disabled>
                                        Select
                                      </option>
                                      <option value="home">Home</option>
                                      <option value="mobile">Mobile</option>
                                      <option value="office">Office</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-8">
                                <PhoneInput
                                  country={"us"}
                                  enableSearch={true}
                                  countryCodeEditable={false}
                                  inputClass="phoneNumberInput"
                                />
                              </div>
                            </div>
                          ))}
                        <div
                          className={`${classes.customizedButton} customizedButton`}
                        >
                          {!element.isPreDefined && (
                            <select
                              className="form-select fieldTypeSelect"
                              value={selectedFieldTypes[index]}
                              onChange={(e) =>
                                handleFieldTypeChange(e.target.value, index)
                              }
                            >
                              <option disabled value="" selected>
                                <span style={{ color: "#ff0000" }}>*</span>
                                Select Field Type
                              </option>
                              <option value="first_name">First Name</option>
                              <option value="last_name">Last Name</option>
                              <option value="email">Email</option>
                              <option value="card_type">Card Type</option>
                              <option value="company">Company</option>
                              <option value="company_position">
                                Company Position
                              </option>
                              <option value="logo">Logo</option>
                              <option value="background_image">
                                Background Image
                              </option>
                              <option value="profile_image">
                                Profile Image
                              </option>
                              <option value="country">Country</option>
                              <option value="city">City</option>
                              <option value="state">State</option>
                              <option value="address">Address</option>
                              <option value="description">Information</option>
                              <option value="website_url">Website</option>
                              <option value="pronouns">Pronouns</option>
                              <option value="phone_type">Phone Type</option>
                              <option value="country_phone">
                                Country Phone
                              </option>
                              <option value="phone_number">Phone Number</option>
                              <option value="flag_code">Country Flag</option>
                              <option value="facebook">Facebook</option>
                              <option value="instagram">Instagram</option>
                              <option value="linkedIn">LinkedIn</option>
                              <option value="twitter">Twitter</option>
                              <option value="snapChat">SnapChat</option>
                              <option value="tiktok">Tiktok</option>
                              <option value="youtube">Youtube</option>
                              <option value="Google">Google</option>
                              <option value="custom">Custom</option>
                              <option value="other">Other</option>
                            </select>
                          )}
                          {!element.isPreDefined && element.type !== "line" && (
                            <Form.Check
                              type="checkbox"
                              label="Is Required"
                              checked={isRequired[index]}
                              onChange={() => toggleIsRequired(index)}
                            />
                          )}
                          {/* <button
                            type="button"
                            className={`${classes.deleteButton} deleteButton`}
                            onClick={() => removeElement(index)}
                          >
                            <BiSolidTrash />
                          </button> */}
                          {!element.isPreDefined && (
                            <>
                              <button
                                type="button"
                                onClick={() => copyElement(index)}
                              >
                                <MdOutlineContentCopy />
                              </button>
                              {element.type !== "line" && (
                                <button
                                  type="button"
                                  className={`${classes.deleteButton} ${classes.editButton}`}
                                  onClick={() =>
                                    openEditModal(
                                      index,
                                      element.label,
                                      element.options
                                    )
                                  }
                                >
                                  <BiEdit />
                                </button>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    ))}
                  </form>

                  {/* {showSubmitButton && (
                    <div className="text-center mt-4">
                      <button
                        type="submit"
                        className="submitButton"
                        onClick={handleSubmit}
                      >
                        Submit
                      </button>
                    </div>
                  )} */}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <Loader />
      )}
      <Modal show={editingIndex !== null} onHide={() => setEditingIndex(null)}>
        <Modal.Header data-bs-theme="dark" closeButton>
          <Modal.Title>Property Editor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editOptions.length === 0 ? (
            <input
              type="text"
              value={editLabel}
              onChange={(e) => setEditLabel(e.target.value)}
            />
          ) : (
            <div>
              <input
                type="text"
                value={editLabel}
                onChange={(e) => setEditLabel(e.target.value)}
              />
              {editOptions.map((option, index) => (
                <div key={index}>
                  <input
                    type="text"
                    value={option}
                    onChange={(e) => {
                      const newOptions = [...editOptions];
                      newOptions[index] = e.target.value;
                      setEditOptions(newOptions);
                    }}
                  />
                </div>
              ))}
              <button onClick={() => setEditOptions([...editOptions, ""])}>
                Add Option
              </button>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setEditingIndex(null)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={saveEdit}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
      <style type="text/css">
        {`
        .colorBorder{
          border: 2px solid var(--border_color);
          border-radius: 60px;
          padding: 9px 15px 0;
        }
        .form-check-color{
          padding-left: 0;
          position:relative;
        }
        .form-check-color .form-check-input{
          float: none;
          margin-left: 0;
          position: absolute;
          opacity: 0;
          margin-top: 0;
          width: 20px;
          height: 20px;
        }
        .form-check-color .form-check-input + label{margin-bottom:0}
        .form-check-color .form-check-input + label .colorBox {
          width:20px;
          height:20px;
          border-radius:50%;
          border: 3px solid transparent;
        } 
        .form-check-color .form-check-input:checked + label .colorBox {
          width:20px;
          height:20px;
          border-radius:50%;
          border: 3px solid var(--border_color);
        } 
        .phoneInputWrapper {
          border: 2px solid var(--border_color);
          border-radius: 25px;
        }
        .addCardSelect.globalInputWithIcon {
          border: 0 !important;
          border-radius: 0;
          border-right: 2px solid var(--border_color) !important;
        }
        .addPhoneInput .react-tel-input .form-control {
            padding: 18.5px 5px 18.5px 52px;
            border: 0 !important;
            width:100%
        }
        .fieldTypeSelect, .fieldTypeSelect:focus{
          display: inline-block;
          padding-top: .235rem;
          padding-bottom: .235rem;
          margin-bottom: 0;
          margin-right: 0.5em;
          background-color: var(--accent_color);
          border: 1px solid var(--accent_color);
          border-radius: 5px;
          color: #333333;
          width: auto;
          font-size: 11px;
          font-weight: 400;
          box-shadow:none;
        }
        .formWrapper h5{
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          margin-bottom:10px;
        }
        .formWrapper h6{
          font-size: 11px;
          font-weight: 400;
          color: #333333;
          margin-bottom:10px;
        }
        .formName .globalInputWithIcon{
        }
        .formName .globalInputWithIcon .form-control{
        }
        .formInputWrapper .form-check-label, label {
          font-size: 13px;
          font-weight: 400;
        }
        .globalTextArea{
          height:100px
        }
        .globalInputUpload input{
          // background: var(--secondary_color);
          border-left: 0;
          box-shadow: none;
          font-size: 14px;
          line-height: 100%;
          padding: 20px 10px;
          color: var(--primary_text_color);
          border: 0;
          margin-left: 0px;
          opacity:0    
        }
        .globalInputUpload span{
          position:absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 14px;
        }
        .globalInputUpload {
          border: 2px dashed var(--border_color);
          border-radius: 10px;
          position:relative;
        }
        .customizedButton .form-check {
          display: inline-block;
          padding-left: 0.5rem;
          padding-right: 1.7em;
          margin-bottom: 0;
          margin-right: 0.5em;
          background-color: var(--accent_color);
          border: 1px solid var(--accent_color);
          border-radius: 5px;
        }
        .customizedButton .form-check .form-check-input {
          float: right;
          margin-right: -1.2em;
          width:0.75em;
          height:0.75em;
          border-radius: 0.15em;
          margin-top:0.42em;
        }
        .customizedButton .form-check .form-check-label {
          font-size: 11px;
        }
        .modal{padding-right:0 !important;}
        .modal.fade .modal-dialog{
          transform: translate(50px, 0);
        }
        .modal.show .modal-dialog {
          transform: none;
        }
        .modal-dialog{
          margin: 0;
          margin-left: auto;
          margin-right: 0;
          height: 100vh;
        }
        .modal-content{
          height: 100%;
          border-radius: 0;
          border: 0;
        }
        .modal-header, .modal-footer{
        }
        .modal-title{
          font-size:16px;
          font-weight: 600;
        }
        .modal-header .btn-close{
          background-size: 0.65em;
          opacity:1
        }
        @media only screen and (min-width: 576px){
          .modal-dialog{
            max-width: 26%;
          }
        }
      `}
      </style>
    </>
  );
}

export default ViewFormBuilder;
